// extracted by mini-css-extract-plugin
module.exports = {"beachHouseOuter":"style_beachHouseOuter__h4Sp4","beachHouseWrapper":"style_beachHouseWrapper__V8w3E","fahidHouseHeader":"style_fahidHouseHeader___zK2D"};